import { CouponApplyErrorCode } from "../../core/enums";
import { CouponApplyPhase } from "./interfaces/coupon-qualifier.interface";
export class OrderTypeQualifier {
    phase = CouponApplyPhase.PreApply;
    qualify(coupon, cart) {
        const offered = coupon.orderTypeSubTypes.some(x => x.orderTypeId === cart.orderTypeId && (x.orderTypeSubId === null || x.orderTypeSubId === cart.orderTypeSubId));
        if (!offered) {
            return { isValid: false, errorCode: CouponApplyErrorCode.INVALID_ORDER_TYPE };
        }
        return { isValid: true, errorCode: null };
    }
}
//# sourceMappingURL=order-type.js.map